import Header from 'components/headers/funds'
import SideBar from 'components/sidebar'
import SideBarItems from 'components/sidebar/items'
import Funds from 'modules/funds'

export default function FundsPage() {
    return (
        <>
            <Header title="صندوق ها" />
            <SideBar>
                <SideBarItems />
            </SideBar>
            <Funds />
        </>
    )
}
